import React, { Component } from "react";
import axios from "../../utils/axiosInstance";
import Swal from "sweetalert2";

class Incomes extends Component {
  state = {
    incomes: [],
    categories: [],
    formData: {
      id: null,
      income_category_id: "",
      income_description: "",
      income_amount: "",
      income_date: "",
      income_status: "",
      income_img: null,
    },
    imagePreview: "",
    deleteId: null,
    error: "",
    loading: false,
    submitting: false,
    modalMode: "add",
  };

  componentDidMount() {
    this.fetchCategories();
    this.fetchIncomes();

    const modalEl = document.getElementById("incomeModal");
    if (modalEl) {
      modalEl.addEventListener("hidden.bs.modal", () => {
        this.resetForm();
      });
    }
  }

  /** ✅ Fetch income Categories */
  fetchCategories = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get("/incomes/categories", {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = res.data?.data || [];
      this.setState({ categories: Array.isArray(data) ? data : [] });
    } catch (err) {
      console.error("Failed to load categories:", err);
    }
  };

  /** ✅ Fetch all incomes */
  fetchIncomes = async () => {
    this.setState({ loading: true, error: "" });
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get("/incomes", {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = res.data?.data || [];
      this.setState({ incomes: Array.isArray(data) ? data : [] });
    } catch (err) {
      this.setState({
        error:
          err.response?.data?.message ||
          "Failed to load incomes. Please try again.",
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  /** ✅ Reset form when modal closes */
  resetForm = () => {
    this.setState({
      formData: {
        id: null,
        income_category_id: "",
        income_description: "",
        income_amount: "",
        income_date: "",
        income_status: "",
        income_img: null,
      },
      imagePreview: "",
      error: "",
      submitting: false,
      modalMode: "add",
    });
  };

  /** ✅ Input change handler */
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prev) => ({
      formData: { ...prev.formData, [name]: value },
    }));
  };

  /** ✅ File upload preview handler */
  handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      this.setState((prev) => ({
        formData: { ...prev.formData, income_img: file },
        imagePreview: URL.createObjectURL(file),
      }));
    }
  };

  /** ✅ Open modal for add/edit */
  openModal = (mode = "add", income = null) => {
    const modal = new window.bootstrap.Modal(document.getElementById("incomeModal"));
    const baseUrl = axios.defaults.baseURL.replace("/api", "");

    if (mode === "edit" && income) {
      this.setState({
        modalMode: "edit",
        formData: {
          id: income.id,
          income_category_id: income.income_category_id || "",
          income_description: income.income_description || "",
          income_amount: income.income_amount || "",
          income_date: income.income_date || "",
          income_status: income.income_status?.toString() ?? "1",
          income_img: null,
        },
        imagePreview: income.income_img
          ? `${baseUrl}/uploads/incomes/${income.income_img}`
          : "",
        error: "",
      });
    } else {
      this.resetForm();
    }

    modal.show();
  };

  /** ✅ Submit (add or update) */
  handleSubmit = async (e) => {
    e.preventDefault();
    const { formData, modalMode } = this.state;

    if (!formData.income_category_id)
      return this.setState({ error: "Category is required." });
    if (!formData.income_description)
      return this.setState({ error: "income description is required." });
    if (!formData.income_amount)
      return this.setState({ error: "income amount is required." });
    if (!formData.income_date)
      return this.setState({ error: "income date is required." });
    if (formData.income_status === "")
      return this.setState({ error: "Status is required." });

    const data = new FormData();
    data.append("income_category_id", formData.income_category_id);
    data.append("income_description", formData.income_description);
    data.append("income_amount", formData.income_amount);
    data.append("income_date", formData.income_date);
    data.append("income_status", formData.income_status);
    if (formData.income_img) data.append("income_img", formData.income_img);

    this.setState({ submitting: true, error: "" });

    try {
      const token = localStorage.getItem("token");
      if (modalMode === "add") {
        await axios.post("/incomes", data, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        });
      } else {
        await axios.post(`/incomes/${formData.id}?_method=PUT`, data, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        });
      }

      await this.fetchIncomes();
      const modal = window.bootstrap.Modal.getInstance(document.getElementById("incomeModal"));
      modal.hide();

      Swal.fire({
        icon: "success",
        title:
          modalMode === "add"
            ? "income added successfully!"
            : "income updated successfully!",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (err) {
      console.error(err);
      this.setState({
        error:
          err.response?.data?.message ||
          err.response?.data?.error ||
          "Error saving income.",
      });
    } finally {
      this.setState({ submitting: false });
    }
  };

  /** ✅ Confirm Delete */
  confirmDelete = (id) => {
    this.setState({ deleteId: id });
    const modal = new window.bootstrap.Modal(document.getElementById("deleteModal"));
    modal.show();
  };

  /** ✅ Delete income */
  handleDelete = async () => {
    const { deleteId } = this.state;
    if (!deleteId) return;

    try {
      const token = localStorage.getItem("token");
      await axios.delete(`/incomes/${deleteId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      await this.fetchIncomes();

      const modal = window.bootstrap.Modal.getInstance(document.getElementById("deleteModal"));
      modal.hide();

      Swal.fire({
        icon: "success",
        title: "income deleted successfully!",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch {
      Swal.fire({
        icon: "error",
        title: "Failed to delete income.",
      });
    }
  };

  render() {
    const {
      incomes,
      categories,
      formData,
      imagePreview,
      error,
      loading,
      submitting,
      modalMode,
    } = this.state;

    const baseUrl = axios.defaults.baseURL.replace("/api", "");

    return (
      <div className="pc-container">
        <div className="pc-content">
          <div className="row">
            <div className="col-lg-12">
              <div className="card shadow-none">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <ul className="breadcrumb mb-0">
                    <li className="breadcrumb-item">Incomes</li>
                    <li className="breadcrumb-item active">List</li>
                  </ul>
                  <button
                    type="button"
                    className="btn btn-light-warning"
                    onClick={() => this.openModal("add")}
                  >
                    + New Income
                  </button>
                </div>

                <div className="card-body">
                  {error && <div className="alert alert-danger">{error}</div>}
                  {loading ? (
                    <div className="text-center py-4">Loading...</div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Category</th>
                            <th>Description</th>
                            <th>Amount</th>
                            <th>Date</th>
                            <th>Image</th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {incomes.length ? (
                            incomes.map((exp, index) => (
                              <tr key={exp.id}>
                                <td>{index + 1}</td>
                                <td>{exp.income_category_name || "N/A"}</td>
                                <td>{exp.income_description}</td>
                                <td>{exp.income_amount}</td>
                                <td>{exp.income_date}</td>
                                <td>
                                  {exp.income_img ? (
                                    <img
                                      src={`${baseUrl}/uploads/incomes/${exp.income_img}`}
                                      alt="img"
                                      style={{
                                        width: "50px",
                                        height: "50px",
                                        borderRadius: "6px",
                                      }}
                                    />
                                  ) : (
                                    "No Image"
                                  )}
                                </td>
                                <td>
                                  {exp.income_status === "1" ||
                                  exp.income_status === 1 ? (
                                    <span className="badge bg-success">Active</span>
                                  ) : (
                                    <span className="badge bg-danger">Inactive</span>
                                  )}
                                </td>
                                <td>
                                  <button
                                    className="btn btn-sm btn-light-success me-2"
                                    onClick={() => this.openModal("edit", exp)}
                                  >
                                    <i className="ph ph-note-pencil"></i>
                                  </button>
                                  <button
                                    className="btn btn-sm btn-light-danger"
                                    onClick={() => this.confirmDelete(exp.id)}
                                  >
                                    <i className="ph ph-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="8" className="text-center">
                                No incomes found.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ✅ Add/Edit Modal */}
        <div className="modal fade" id="incomeModal" tabIndex={-1}>
          <div className="modal-dialog">
            <div className="modal-content">
              <form onSubmit={this.handleSubmit}>
                <div className="modal-header">
                  <h5 className="modal-title">
                    {modalMode === "add" ? "Add income" : "Edit Income"}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                  ></button>
                </div>

                <div className="modal-body">
                  {/* Category */}
                  <div className="mb-3">
                    <label className="form-label">Select Category</label>
                    <select
                      name="income_category_id"
                      className="form-select"
                      value={formData.income_category_id}
                      onChange={this.handleChange}
                      required
                    >
                      <option value="">-- Select Category --</option>
                      {categories.map((cat) => (
                        <option key={cat.id} value={cat.id}>
                          {cat.category_name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* income Description */}
                  <div className="mb-3">
                    <label className="form-label">Income Description</label>
                    <input
                      type="text"
                      name="income_description"
                      className="form-control"
                      value={formData.income_description}
                      onChange={this.handleChange}
                      required
                    />
                  </div>

                  {/* Amount */}
                  <div className="mb-3">
                    <label className="form-label">Amount</label>
                    <input
                      type="number"
                      name="income_amount"
                      className="form-control"
                      value={formData.income_amount}
                      onChange={this.handleChange}
                      required
                    />
                  </div>

                  {/* Date */}
                  <div className="mb-3">
                    <label className="form-label">Income Date</label>
                    <input
                      type="date"
                      name="income_date"
                      className="form-control"
                      value={formData.income_date}
                      onChange={this.handleChange}
                      required
                    />
                  </div>

                  {/* Status */}
                  <div className="mb-3">
                    <label className="form-label">Status</label>
                    <select
                      name="income_status"
                      className="form-select"
                      value={formData.income_status}
                      onChange={this.handleChange}
                      required
                    >
                      <option value="">Select Status</option>
                      <option value="1">Active</option>
                      <option value="0">Inactive</option>
                    </select>
                  </div>

                  {/* Image Upload */}
                  <div className="mb-3">
                    <label className="form-label">Income Image</label>
                    <input
                      type="file"
                      className="form-control"
                      accept="image/*"
                      onChange={this.handleFileChange}
                    />
                    {imagePreview && (
                      <div className="mt-2 text-center">
                        <img
                          src={imagePreview}
                          alt="Preview"
                          style={{ width: "100px", borderRadius: "8px" }}
                        />
                      </div>
                    )}
                  </div>

                  {error && <div className="alert alert-danger">{error}</div>}
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-light-danger"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-light-primary"
                    disabled={submitting}
                  >
                    {submitting
                      ? "Saving..."
                      : modalMode === "add"
                      ? "Add"
                      : "Update"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* ✅ Delete Modal */}
        <div className="modal fade" id="deleteModal" tabIndex={-1}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-danger">
              <div className="modal-body text-center p-4">
                <i className="ph ph-warning text-danger f-40 mb-3"></i>
                <h5>Are you sure?</h5>
                <p className="text-muted mb-4">This action cannot be undone.</p>
                <div className="d-flex justify-content-center gap-3">
                  <button
                    type="button"
                    className="btn btn-light-secondary"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-light-danger"
                    onClick={this.handleDelete}
                  >
                    Yes, Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Incomes;
